<template>
    <div class="page">
        <Navbar v-if="withNavbar"/>
        <div class="content">
            <slot/>
            <transition name="fade">
                <ModalAnalytics v-if="analytics" @close="onAnalyticsClose"/>
            </transition>
        </div>
        <Footer/>
    </div>
</template>
<script>
import { TrackingConsumer } from '../../mixins';

import { ModalAnalytics, Navbar } from '../../components/desktop';
import { Footer } from '../../components/shared';

export default {
    name: 'Page',
    components: {
        Navbar, Footer, ModalAnalytics,
    },
    mixins: [TrackingConsumer],
    props: {
        withNavbar: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            analytics: false,
        };
    },
    created () {
        this.analytics = this.shouldAskConsent;
    },
    methods: {
        onAnalyticsClose () {
            this.analytics = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

.page {
    @include flex-vertical();
    flex-grow: 1;
    position: relative;

    > .content {
        @include flex-vertical();
        flex-grow: 1;
    }
}
</style>
